import { render, staticRenderFns } from "./PartRoleFeatures.vue?vue&type=template&id=15265da7&scoped=true"
import script from "./PartRoleFeatures.vue?vue&type=script&setup=true&lang=js"
export * from "./PartRoleFeatures.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PartRoleFeatures.vue?vue&type=style&index=0&id=15265da7&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15265da7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15265da7')) {
      api.createRecord('15265da7', component.options)
    } else {
      api.reload('15265da7', component.options)
    }
    module.hot.accept("./PartRoleFeatures.vue?vue&type=template&id=15265da7&scoped=true", function () {
      api.rerender('15265da7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/role/components/PartRoleFeatures.vue"
export default component.exports